import VideoPlayer from "@/components/video/videoPlayer/index"
import WistiaPlayer from "@/components/video/wistiaPlayer"

import VideoDis from "@/components/video/videoDis"
import VideoComments from "@/components/video/videoComments/main"
import SeriesList from "@/components/video/seriesList/index"
import BottomSeries from "@/components/video/bottomSeries"

import { commentsStatus, screenStaus } from "@/pages/watch/main/constants"
import "./style.css"
import { useAuthToken } from "@/hooks/useAppSelectors"
import { hasQueryParam } from "@/utils"
import { allQueryParam } from "@/constants/urlPaths"
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
export default function WatchMobileTabMainView(props: any) {
    const token = useAuthToken();
    // console.log(props.currentVideoObj)
    const currentVideoType = props.currentVideoObj?.videoType?.type;
    const isDefaultVideoPlayer = currentVideoType !== "wistia";
    const { topSafeComponent, bottomSafeComponent } = useSafeAreaInsets();
    return (
        <div className={`watchMobileTabMainView
            ${!token ? 'watchMobileTabMainView_isPublicVideo' : ''}`}>
            {/* ${isPublicVideo(props.currentVideoObj) ? 'watchMobileTabMainView_isPublicVideo' : ''}`}> */}
            {props.currentScreenStatus === screenStaus.seriesScreen &&
                <SeriesList
                    seriesDetails={props.seriesDetails}
                    updateCurrentVideoObj={props.updateCurrentVideoObj}
                    isLoading={props.isLoading}
                    currentVideoObj={props.currentVideoObj}
                    isWelcomeSeries={props.isWelcomeSeries}
                />
            }
            {topSafeComponent}
            {props.currentScreenStatus === screenStaus.videoScreen &&
                <>
                    {isDefaultVideoPlayer ? (
                        <VideoPlayer
                            isLoading={props.isLoading}
                            playNextVideo={props.playNextVideo}
                            isWelcomeSeries={props.isWelcomeSeries}
                        />
                    ) : (
                        <WistiaPlayer
                            isWelcomeSeries={props.isWelcomeSeries}
                            playNextVideo={props.playNextVideo}
                            title={props.currentVideoObj?.title || "Wistia video"}
                            containerClassName="wistiaIframeConMobile"
                        />
                    )}

                    <VideoDis
                        isLoading={props.isLoading}
                        currentVideoObj={props.currentVideoObj}
                        seriesNotes={props.seriesNotes}
                        isWelcomeSeries={props.isWelcomeSeries}
                        seriesId={props.seriesId}
                        isSubscribedSeries={props.isSubscribedSeries}
                        isPGCourseSeries={props.isPGCourseSeries}
                    />

                    {props.currentVideoObj
                        && props.currentVideoObj.commentsStatus
                        && props.currentVideoObj.commentsStatus !== commentsStatus.disabled ? (
                        <VideoComments
                            isLoading={props.isLoading}
                            currentVideoObj={props.currentVideoObj}
                            isWelcomeSeries={props.isWelcomeSeries}
                        />
                    ) : (
                        <div className="h-[120px] invisible">
                            note : hide it to add extra space when comments are not there
                        </div>
                    )
                    }
                    {bottomSafeComponent}
                    {props.currentVideoObj
                        && (hasQueryParam(allQueryParam.series) && token) &&
                        // && !isPublicVideo(props.currentVideoObj) &&
                        <BottomSeries
                            currentVideoObj={props.currentVideoObj}
                            seriesDetails={props.seriesDetails}
                            updateCurrentVideoObj={props.updateCurrentVideoObj}
                            isLoading={props.isLoading}
                            isWelcomeSeries={props.isWelcomeSeries}
                        />
                    }
                </>
            }
        </div>
    );
}


